import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const openContact = () => {
    setIsContactOpen(true);
    setIsMenuOpen(false);
  };

  const closeContact = () => {
    setIsContactOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          {/* Logo/Name Section */}
          <div className="header-brand">
            <h1 className="header-name">Dr. Rajkamal Upadhyaya</h1>
            <p className="header-title">Academic Professional | Accounting & Financial Management</p>
          </div>

          {/* Navigation */}
          <nav className={`header-nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <button 
                  onClick={() => scrollToSection('profile')}
                  className="nav-link"
                >
                  Profile
                </button>
              </li>
              <li className="nav-item">
                <button 
                  onClick={() => scrollToSection('experience')}
                  className="nav-link"
                >
                  Experience
                </button>
              </li>
              <li className="nav-item">
                <button 
                  onClick={() => scrollToSection('research')}
                  className="nav-link"
                >
                  Research & Publications
                </button>
              </li>
              <li className="nav-item">
                <button 
                  onClick={() => scrollToSection('achievements')}
                  className="nav-link"
                >
                  Achievements
                </button>
              </li>
              <li className="nav-item">
                
              </li>
              <li className="nav-item">
                <button 
                  onClick={openContact}
                  className="nav-link contact-btn"
                >
                  Contact
                </button>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className={`menu-icon ${isMenuOpen ? 'menu-open' : ''}`}>
              <span className="menu-bar"></span>
              <span className="menu-bar"></span>
              <span className="menu-bar"></span>
            </span>
          </button>
        </div>
      </header>

      {/* Contact Modal */}
      {isContactOpen && (
        <div className="contact-overlay" onClick={closeContact}>
          <div className="contact-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="close-contact"
              onClick={closeContact}
            >
              ×
            </button>
            <div className="contact-header">
              <h3>Contact Information</h3>
              <div className="contact-divider"></div>
            </div>
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div className="contact-info">
                  <strong>Email</strong>
                  <a href="mailto:rajkamalupadhyaya@gmail.com">rajkamalupadhyaya@gmail.com</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📱</div>
                <div className="contact-info">
                  <strong>Phone</strong>
                  <div className="phone-numbers">
                    <a href="tel:+919759477711">+91 97594 77711</a>
                    <a href="tel:+919410685711">+91 94106 85711</a>
                  </div>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-info">
                  <strong>Address</strong>
                  <p>D202, VTP Urban Life, MIDC Road, Talegaon<br />Pune, Maharashtra - 410507</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;